// Copyright (c) Move Closer 2022.

import { CountryData } from './contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const shipmentAdapter = (countries: any): CountryData[] => {
  return countries.map((country: any) => {
    return {
      id: country.id,
      availableRegions: country.available_regions,
      fullNameEnglish: country.full_name_english,
      fullNameLocale: country.full_name_locale,
      twoLetterAbbreviation: country.two_letter_abbreviation
    }
  })
}
